import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React from 'react';
import classes from './UserRecentActivityItem.module.css';
import { formatRecentActivityTimestamp, getRgbFromColorName } from 'shared/utility';

const userRecentActivityItem = (props) => {
  const goToUrl = props.userActivity.Goto === 'Post' ? `/life-shared/posts/${props.userActivity.GotoId}` : undefined;
  const activityInitiatorName =
    props.userActivity.Details.Vars.Someone.Id === props.postingAs.UserId
      ? props.userActivity.Details.Vars.Someone.IfYou
      : props.userActivity.Details.Vars.Someone
      ? props.userActivity.Details.Vars.Someone.Text
      : '';
  let activityDescription = props.userActivity.Title.replace('[[Someone]]', activityInitiatorName);
  if (activityDescription.includes('[[From]]') && props.userActivity.CreatedBy)
    activityDescription = activityDescription.replace('[[From]]', props.userActivity.CreatedBy.FirstName);
  const imageURL = _get(props, 'userActivity.CreatedBy.ImageURL', _get(props, 'userActivity.CreatedBy.ThumbURL'));
  return (
    <div className={classes.Container} onClick={() => props.clicked(goToUrl)}>
      {imageURL && imageURL.charAt(imageURL.length - 1) ? (
        <img
          src={imageURL}
          style={{ border: `3px solid ${getRgbFromColorName(props.userActivity.CreatedBy.Color)}` }}
          alt={props.userActivity.Details.Vars.Title ? props.userActivity.Details.Vars.Title.Text : ''}
          className={classes.ThumbImage}
        />
      ) : (
        <FontAwesomeIcon
          icon="user"
          style={{
            border: `3px solid ${getRgbFromColorName(props.userActivity.CreatedBy.Color)}`,
            color: getRgbFromColorName(props.userActivity.CreatedBy.Color),
          }}
          className={classes.AvatarImage}
        />
      )}
      <div className={classes.Details}>
        <div className={classes.Content}>
          <p className={classes.ActivityDescription}>{activityDescription}</p>
          {props.userActivity.Details.Vars.Title ? <h3>{props.userActivity.Details.Vars.Title.Text}</h3> : null}
        </div>
        <p className={classes.ActivityTimeStamp}>{formatRecentActivityTimestamp(props.userActivity.DateCreated)}</p>
      </div>
    </div>
  );
};

export default userRecentActivityItem;
